import { useReactiveVar } from '@apollo/client';
import { Meta, theme, Title } from 'aimo-ui';
import HslContext from 'context/HslContext';
import React, { useContext } from 'react';
import { country } from 'states/persistInStorage';
import { useHslStore } from 'stores/hslStore';
import styled from 'styled-components/native';
import { StyledWrapper } from 'styles/ContainerStyles';
import { currencyFormatter } from 'utils/commonUtils';
import PaymentCardDropDown from '../detail/PaymentCardDropDown';

const ItemContainer = styled.View`
  flex-direction: row;
  align-items: center;
  padding: 15px 0;
  width: 100%;
`;

const Content = styled.View<{
  width?: string;
  alignRight?: boolean;
  marginRight?: string;
}>`
  ${(p) => (p.width ? `width: ${p.width}px;` : '')}
  ${(p) => (!p.alignRight ? 'flex-shrink: 0;' : 'flex: 1;')}
  flex-direction: row;
  justify-content: ${(p) => (p.alignRight ? 'flex-end' : 'flex-start')};
  margin-right: ${(p) => (p.marginRight ? p.marginRight + 'px' : '0px')};
`;

const HslPricingView: React.FC = () => {
  const { selectedSubscriptionType } = useContext(HslContext);
  const pricingSelection = useHslStore((state) => state.selectedHslPricing);
  const countryCode = useReactiveVar(country);
  return (
    <ItemContainer testID="hsl-pricing-view">
      <Content>
        <StyledWrapper>
          <Meta color={theme.colors.gray300}>Total amount</Meta>
          <Title>
            {currencyFormatter(
              ((selectedSubscriptionType === 'AUTOSAVER'
                ? pricingSelection?.subscriberPrice
                : pricingSelection?.currentPrice) as number) / 100 || 0,
              countryCode,
              true
            )}
          </Title>
        </StyledWrapper>
      </Content>
      <Content alignRight>
        <PaymentCardDropDown />
      </Content>
    </ItemContainer>
  );
};

export default HslPricingView;
